import { endpointsSpeckle } from "./endpointsSpeckle";
import { authenticatedAxios } from "lib/actions/fetcher";

export async function speckleValidateAccount(
  speckleConnectedAccountId: string,
): Promise<boolean> {
  return await authenticatedAxios
    .get<void>(endpointsSpeckle.validateAccount(speckleConnectedAccountId))
    .then((resp) => {
      return resp.status === 204;
    })
    .catch((error) => {
      console.error("Error validating account", error);
      return false;
    });
}
